module.exports = __webpack_public_path__ + "static/profile-ff8361e5f271db6a2c547eb6ae65c21b.jpg";